module.exports = __webpack_public_path__ + "static/media/olake-product-2.d47210d5.svg";